<template>
  <v-stepper v-model="e1" elevation="0">
          <v-stepper-header>
            <v-stepper-step color="primary" :complete="e1 > 1" step="1">{{languaje=='true'?'GENERAL INFORMATION':'DATOS GENERALES'}}</v-stepper-step>
            <v-divider/>
            <v-stepper-step color="primary" :complete="e1 > 2" step="2">{{languaje=='true'?'PERSONAL INFORMATION':'DATOS PERSONALES'}}</v-stepper-step>
            <v-divider/>
            <v-stepper-step color="primary" :complete="e1 > 3" step="3">{{languaje=='true'?'BUSINESS OR COMPANY':'EMPRESA O COMPAÑIA'}}</v-stepper-step>
            <v-divider/>
            <v-stepper-step color="primary" :complete="e1 > 4" step="4">{{languaje=='true'?'BILLING':'FACTURACIÓN'}}</v-stepper-step>
            <v-divider/>
            <v-stepper-step color="primary" :complete="e1 > 5" step="5"></v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
              <v-stepper-content step="1">

                <v-row align="center" justify="center">
                  <v-col cols="12">
                    <v-radio-group color="primary" row v-model="languaje" mandatory>
                      <v-radio color="primary" label="(Es) Español" value="false"/>
                      <v-radio color="primary" label="(En) English" value="true"/>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <h3>1. {{content.questionOne }}</h3>
                    <v-chip-group class="mt-1" mandatory v-model="forms.member">
                      <v-chip :value="true" filter active-class="primary white--text" >{{content.answerYes }}</v-chip>
                      <v-chip filter :value="false" active-class="primary white--text">No</v-chip>
                    </v-chip-group>
                  </v-col>
                </v-row>
                <br>
                <h3>2. {{content.questionTwo }}</h3>
                <br>
                <v-row>
                  <v-col cols="12">
                    <v-chip-group column mandatory v-model="forms.typeMember">
                        <v-chip :value="1" filter active-class="primary">{{languaje=='true'?'Speaker':'Conferencista'}}</v-chip>
                        <v-chip :value="6" filter active-class="primary">{{languaje=='true'?'VIP/Courtesy':'VIP/ Cortesía'}}</v-chip>
                        <v-chip :value="4" filter active-class="primary">{{languaje=='true'?'General Attendee':'Participante General'}}</v-chip>
                        <v-chip :value="5" filter active-class="primary">{{languaje=='true'?'General Attendee (1 Day)':'Participante General x 1 Día'}}</v-chip>
                        <v-chip :value="3" filter active-class="primary">{{languaje=='true'?'Booth Model/Visitor':'Modelo de Stand/ Visitante Muestra'}}</v-chip>
                        <v-chip :value="2" filter active-class="primary">{{languaje=='true'?'Spouse/Companion':'Esposa(o)/ Acompañante'}}</v-chip>
                    </v-chip-group>

                  </v-col>
                </v-row>
                <br>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn color="primary" @click="setInfo">{{languaje=='true'?'Next':'Siguiente'}}</v-btn>
                </v-card-actions>

              </v-stepper-content>
              <v-stepper-content step="2">
                
                <ValidationObserver ref="uno" v-slot="{ handleSubmit, invalid }">
                    <v-form style="padding: 3%;" @submit.prevent="handleSubmit(e1++)">

                      <v-row>
                        <v-col cols="12" md="6">
                          <span>{{languaje=='true'?'ID':'Tipo de documento'}}</span>
                          <v-radio-group row v-model="forms.documentType" mandatory>
                            <v-radio value="Cédula de Ciudadanía" :label="languaje=='true'?'Social Security Number':'Cédula de Ciudadanía'"></v-radio>
                            <v-radio value="Cédula de Extranjeria" :label="languaje=='true'?'Foreigner':'Cédula de Extranjeria'"></v-radio>
                            <v-radio value="Pasaporte" :label="languaje=='true'?'Passport':'Pasaporte'"></v-radio>
                          </v-radio-group>
                          <ValidationProvider v-slot="{ errors }" name="N° Documento/ID Number" rules="required">
                            <v-text-field v-model="forms.document" :label="languaje=='true'?'ID Number':'N° Documento'" :error-messages="errors" rounded filled dense/>
                          </ValidationProvider>

                          <ValidationProvider v-slot="{ errors }" name="Nombre/Name" rules="required">
                            <v-text-field v-model="forms.name" :error-messages="errors" :label="languaje=='true'?'Name':'Nombres'" rounded filled dense/>
                          </ValidationProvider>

                          <ValidationProvider v-slot="{ errors }" name="Apellidos/Last Name" rules="required">
                            <v-text-field :error-messages="errors" v-model="forms.lastname" :label="languaje=='true'?'Last Name':'Apellidos'" rounded filled dense/>
                          </ValidationProvider>
                          
                          <span>{{languaje=='true'?'Gender':'Genero'}}</span>
                          <v-radio-group row v-model="forms.gender" mandatory>
                            <v-radio value="F" label="F"></v-radio>
                            <v-radio value="M" label="M"></v-radio>
                            <v-radio value="Otro" :label="languaje=='true'?'Other':'Otro'"></v-radio>
                          </v-radio-group>
                        </v-col>
                        <v-col cols="12" md="6">
                          <ValidationProvider v-slot="{ errors }" name="Correo Electrónico/E-mail" rules="required">
                            <v-text-field :error-messages="errors" type="email" :label="languaje=='true'?'E-mail':'Correo Electrónico'" filled rounded dense v-model="forms.email"/>
                          </ValidationProvider>
                          <ValidationProvider v-slot="{ errors }" name="Teléfono/Cellphone Number" rules="required">
                            <v-text-field :error-messages="errors" :label="languaje=='true'?'Cellphone Number':'Teléfono/Celular'" type="number" filled rounded dense v-model="forms.phone"/>
                          </ValidationProvider>

                          <ValidationProvider v-slot="{ errors }" name="País de residencia/Country" rules="required">
                            <v-autocomplete :error-messages="errors" :items="countrys" v-model="forms.country" :loading="countring" :label="languaje=='true'?'Country':'País de residencia'" dense filled rounded/>
                          </ValidationProvider>
                          <ValidationProvider v-slot="{ errors }" name="Ciudad de residencia/City" rules="required">
                            <v-text-field :error-messages="errors" :label="languaje=='true'?'City':'Ciudad de residencia'" filled rounded dense v-model="forms.cityPerson"/>
                          </ValidationProvider>
                          <ValidationProvider v-slot="{ errors }" name="Dirección/Address" rules="required">
                            <v-text-field :error-messages="errors" :label="languaje=='true'?'Address':'Dirección'" filled rounded dense v-model="forms.address"/>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-card-actions>
                        <v-spacer/>
                        <v-btn color="primary" @click="e1--" text>{{languaje=='true'?'Back':'Atras'}}</v-btn>
                        <v-btn color="primary" :disabled="invalid" type="submit">{{languaje=='true'?'Next':'Siguiente'}}</v-btn>
                      </v-card-actions>

                    </v-form>
                </ValidationObserver>

              </v-stepper-content>

              <v-stepper-content step="3">
                
                <ValidationObserver ref="dos" v-slot="{ handleSubmit, invalid }">
                    <v-form style="padding: 3%;" @submit.prevent="handleSubmit(nextFour)">

                
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-checkbox :label="languaje=='true'?'Does Not Apply':'No Aplica'" v-model="forms.companies"/>
                        </v-col>
                      </v-row>
                      <v-row>
                        <br>
                        <v-col cols="12" md="6">
                          <ValidationProvider v-slot="{ errors }" name="Company/Compañía" rules="required">
                            <v-text-field :error-messages="errors" :label="languaje=='true'?'Company':'Compañía'" rounded filled dense v-model="forms.company" :disabled="forms.companies"/>
                          </ValidationProvider>

                          <ValidationProvider v-slot="{ errors }" name="Titulo Laboral/Job Title" rules="required">
                            <v-text-field :error-messages="errors" :label="languaje=='true'?'Job Title':'Titulo Laboral'" rounded filled dense :disabled="forms.companies" v-model="forms.jobtitle"/>
                          </ValidationProvider>
                          
                          
                          <div v-if="forms.companies">
                            <v-text-field  :label="languaje=='true'?'Country':'País'" dense filled rounded disabled v-model="forms.countryCompany" :value="'N/A'"/>
                          </div>
                          <div v-else>
                            <ValidationProvider v-slot="{ errors }" name="País/Country" rules="required">
                              <v-autocomplete :error-messages="errors"  :items="countrys" item-text="name.common" item-value="name.common" :label="languaje=='true'?'Country':'País'" dense filled rounded :disabled="forms.companies" v-model="forms.countryCompany"/>
                            </ValidationProvider>
                          </div>
                        </v-col>
                        <v-col cols="12" md="6">
                          <ValidationProvider v-slot="{ errors }" name="Ciudad/City" rules="required">
                            <v-text-field :error-messages="errors" :label="languaje=='true'?'City':'Ciudad'" rounded filled dense v-model="forms.cityCompany" :disabled="forms.companies"/>
                          </ValidationProvider>
                          <ValidationProvider v-slot="{ errors }" name="Dirección de la Compañía/Company Address" rules="required">
                            <v-text-field :error-messages="errors" :label="languaje=='true'?'Company Address':'Dirección de la Compañía'" rounded filled dense :disabled="forms.companies" v-model="forms.addressCompany"/>
                          </ValidationProvider>

                        </v-col>
                      </v-row>
                      <v-card-actions>
                        <v-spacer/>
                        <v-btn color="primary" text @click="e1--">{{languaje=='true'?'Back':'Atras'}}</v-btn>
                        <v-btn color="primary" :disabled="invalid" type="submit">{{languaje=='true'?'Next':'Siguiente'}}</v-btn>
                      </v-card-actions>

                    </v-form>
                </ValidationObserver>


              </v-stepper-content>

              <v-stepper-content step="4">
                <ValidationObserver ref="formtype" v-slot="{ handleSubmit, invalid }">
                    <v-form style="padding: 3%;" @submit.prevent="handleSubmit(save)">

                      <v-row>
                        <v-col cols="12" md="6">
                          <v-radio-group row mandatory v-model="forms.typeInvoice">
                            <v-radio :value="1" :label="languaje=='true'?'Company':'Empresa'"/>
                            <v-radio :value="2" :label="languaje=='true'?'Individual':'Personal Natural'"/>
                            <v-radio :value="3" :label="languaje=='true'?'N/A':'No Aplica'"/>
                          </v-radio-group>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6">
                          <ValidationProvider v-slot="{ errors }" name="Nombre/Name" rules="required">
                            <v-text-field :error-messages="errors" :label="languaje=='true'?'Name':'A nombre de:'" rounded filled dense v-model="forms.nameToInvoice" :disabled="forms.typeInvoice==3" />
                          </ValidationProvider>
                          <ValidationProvider v-slot="{ errors }" name="Documento/ID Number" rules="required">
                            <v-text-field :error-messages="errors" :label="languaje=='true'?'ID Number':'N° Documento de Identificación'" rounded filled dense v-model="forms.documentInvoice" :disabled="forms.typeInvoice==3"/>
                          </ValidationProvider>

                        </v-col>
                        <v-col cols="12" md="6">
                          <ValidationProvider v-slot="{ errors }" name="Dirección/Address" rules="required">
                            <v-text-field :error-messages="errors" :label="languaje=='true'?'Address':'Dirección'" rounded filled dense v-model="forms.addressInvoice" :disabled="forms.typeInvoice==3"/>
                          </ValidationProvider>
                          
                          <ValidationProvider v-slot="{ errors }" name="Email" rules="required">
                            <v-text-field :error-messages="errors" :label="languaje=='true'?'Contact for payments (e-mail)':'Contacto para pagos (E-mail)'" rounded filled dense v-model="forms.emailInvoice" :disabled="forms.typeInvoice==3"/>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-card-actions>
                          <v-spacer/>
                          <v-btn color="primary" :disabled="loading" text @click="e1--">{{languaje=='true'?'Back':'Atras'}}</v-btn>
                          <v-btn color="primary" :loading="loading" :disabled="invalid" type="submit">{{languaje=='true'?'Save':'Guardar'}}</v-btn>
                      </v-card-actions>

                    </v-form>
                </ValidationObserver>
              </v-stepper-content>

              <v-stepper-content step="5">
                  
                  

                    {{languaje=='true'?'Thank you for registering for the XVIII SLOM Jornada!':'¡Gracias por realizar tu inscripción a la XVIII Jornada SLOM!'}}
                    <br>
                    <br>
                    {{languaje=='true'?'You will receive an email shortly to complete the process. In case you do not receive it or require additional support, please contact to':'En breve recibirás un email para completar el proceso. En caso de no recibirlo o requerir soporte adicional, por favor escribir a'}}
                    
                  soportejornadaslom2022@gmail.com
                  <v-card-actions>
                    <v-spacer/>
                    <v-btn color="primary" @click="e1=1,$emit('closeDialog')">{{languaje=='true'?'Finally':'Finalizar'}}</v-btn>
                  </v-card-actions>
              </v-stepper-content>


          </v-stepper-items>
        
  </v-stepper>
</template>

<script>
import { required } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider} from "vee-validate";
import { db, marcadetiempo } from '../firebase';
import emailjs from '@emailjs/browser'
extend("required", { ...required, message: "{_field_} no puede estar vacío"});
export default {
    components:{ ValidationObserver, ValidationProvider},
    data:()=>({
    forms:{
      member:true,
      typeMember:null,
      
      name:null,
      lastname:null,
      documentType:null,
      document:null,
      gender:null,
      country:null,
      cityPerson:null,
      address:null,
      email:null,
      phone:null,

      companies:false,
      company:null,
      jobtitle:null,
      countryCompany:null,
      cityCompany:null,
      addressCompany:null,

      typeInvoice:1,
      nameToInvoice:null,
      documentInvoice:null,
      addressInvoice:null,
      emailInvoice:null,

      languaje:null,
      
      dateAt:marcadetiempo(),
      dates:null,

      //si ya esta confirmado
      confirm:false,
      //contar cuantos primeros correos le enviamos
      countFirstEmail:1
    },
    languaje:false,
    content:{
      questionOne:null,
      answerYes:null,
      types:[]
    },
    e1: 1,
    countrys:[],
    loading:false,
    templates:{
      type:null,
      price:null,
      url:null,
      template:null,
      type_url:null,
    },
    countring:false,
    esono:null
  }),
  methods:{
    fetchLanguaje(lang){
      fetch(lang)
      .then(res=>res.json())
      .then(data=> {
        this.content = data
        
      })
    },
    fetchCountry(){
      this.countring=true
      this.$http.get('https://restcountries.com/v3.1/all').then(res=>{
        let arreglo = res.data.map(x=>x.name.common)
        this.countrys = arreglo.sort()
        //console.log()
      }).finally(()=>{
        this.countring=false
      })
    },
    async save(){
      this.loading= true
      //this.setInfo(this.forms.typeMember)

      const dato = await db.collection('assistant').doc(this.forms.email).get()
      if(dato.data()){
        this.$toast.warning('El correo electrónico personal ya está en uso.')  
        this.loading= false
      }else{
        this.forms.languaje = this.languaje
        await db.collection('assistant').doc(this.forms.email).set(this.forms)
        this.sendEmail()
      }

      
    },
    sendEmail(){
      let esmiembro= ''
      this.forms.member? esmiembro='Miembro SLOM':esmiembro='No Miembro SLOM'
      let template = {
        to_name:`${this.forms.name} ${this.forms.lastname}`,
        type:this.templates.type,
        price:this.templates.price,
        url:this.templates.url,
        linki:this.templates.url,
        member:esmiembro,
        to_email:this.forms.email,
        type_url:this.forms.type_url
      }
      console.log(template)
      emailjs.send('service_nx524vd',this.templates.template,template,'user_8B00XPfvnqrXGs1La3yQu').then(e=>{
        
        if(e.status==200){
          this.$toast.success('Guardado')
        }else{
          this.$toast.error('No logramos enviar el correo')
        }
      }).finally(()=>{
        this.forms = {
          member:true,
          typeMember:null,
          
          name:null,
          lastname:null,
          documentType:null,
          document:null,
          gender:null,
          country:null,
          cityPerson:null,
          address:null,
          email:null,
          phone:null,

          companies:false,
          company:null,
          jobtitle:null,
          countryCompany:null,
          cityCompany:null,
          addressCompany:null,

          typeInvoice:null,
          nameToInvoice:null,
          documentInvoice:null,
          addressInvoice:null,
          emailInvoice:null,
          
          dateAt:marcadetiempo(),
          dates:null,
          confirm:false,
          countFirstEmail:1
        }
        requestAnimationFrame(() => {
          this.$refs.uno.reset();
        });
        requestAnimationFrame(() => {
          this.$refs.dos.reset();
        });
        requestAnimationFrame(() => {
          this.$refs.formtype.reset();
        });
        this.countrys=[]
        this.fetchCountry()
        this.e1++
        this.loading= false
      }).catch(()=>{
      })
      
    },
    async setInfo(){
      this.forms.dates = new Date().toString() 
      if(this.languaje=='false'){
        let typos = await this.$http.get('../Spanish.json')
        if(this.forms.member){
          let typem = typos.data.members.filter(x=>x.id ==this.forms.typeMember)
          this.templates.type = typem[0].name
          this.templates.price = typem[0].price
          this.templates.url = typem[0].link
          this.templates.template = typem[0].template
          this.templates.type_url = typem[0].typeurl
        }else{
          let typem = typos.data.nomembers.filter(x=>x.id ==this.forms.typeMember)
          this.templates.type = typem[0].name
          this.templates.price = typem[0].price
          this.templates.url = typem[0].link
          this.templates.template = typem[0].template
          this.templates.type_url = typem[0].typeurl
        }
      }else{
        let typos = await this.$http.get('../English.json')
        if(this.forms.member){
          let typem = typos.data.members.filter(x=>x.id ==this.forms.typeMember)
          this.templates.type = typem[0].name
          this.templates.price = typem[0].price
          this.templates.url = typem[0].link
          this.templates.template = typem[0].template
          this.templates.type_url = typem[0].typeurl
        }else{
          let typem = typos.data.nomembers.filter(x=>x.id ==this.forms.typeMember)
          this.templates.type = typem[0].name
          this.templates.price = typem[0].price
          this.templates.url = typem[0].link
          this.templates.template = typem[0].template
          this.templates.type_url = typem[0].typeurl
        }
      }
      this.e1++


    },
    nextFour(){
      this.forms.nameToInvoice=this.forms.company
      this.e1++
    }
  },
  created(){
    this.fetchCountry()
  },
  watch:{
    "languaje":function(e){
      let url = e=='true'? url='../English.json':'../Spanish.json'
      this.fetchLanguaje(url)
    },
    "forms.companies":function(e){
      if(e){
        this.forms.company='N/A'
        this.forms.jobtitle='N/A'
        this.forms.cityCompany ='N/A'
        this.forms.addressCompany ='N/A'
        this.forms.countryCompany ='N/A'
      }else{
        this.forms.company=null
        this.forms.jobtitle=null
        this.forms.cityCompany =null
        this.forms.addressCompany =null
        this.forms.countryCompany =null

        //Llenar facturacion
        //this.forms.nameToInvoice=this.forms.company
      }
    },
    "forms.typeInvoice":function(e){
      if(e==3){
        this.forms.nameToInvoice='N/A'
        this.forms.documentInvoice='N/A'
        this.forms.addressInvoice='N/A'
        this.forms.emailInvoice='N/A'
      }else if(e==2){
        this.forms.nameToInvoice=this.forms.name
        this.forms.documentInvoice=this.forms.document
        this.forms.addressInvoice=this.forms.address
        this.forms.emailInvoice=this.forms.email
      }else{
        this.forms.nameToInvoice=null
        this.forms.documentInvoice=null
        this.forms.addressInvoice=null
        this.forms.emailInvoice=null
      }
    },
    "forms.name":function(e){
             this.forms.name = e.toUpperCase();
    },
    "forms.lastname":function(e){
             this.forms.lastname = e.toUpperCase();
    },
    "forms.document":function(e){
             this.forms.document = e.toUpperCase();
    },
    "forms.jobtitle":function(e){
             this.forms.jobtitle = e.toUpperCase();
    },
    "forms.company":function(e){
      this.forms.company = e.toUpperCase();
      if(e!=='N/A'){
        this.forms.nameToInvoice=this.forms.company
      }
    },
    "forms.addressCompany":function(e){
      if(e!=='N/A'){ this.forms.addressInvoice =  this.forms.addressCompany }
      //forms.addressInvoice

    }
    

    
  }

}
</script>

<style>

</style>